var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormaRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 554,
    viewBox: "0 0 457 554",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.741 178.392C102.968 224.832 28.5848 275.736 24.6703 358.336C18.2502 493.226 290.302 577.46 439.769 517.186C589.237 456.911 660.944 313.183 572.243 180.438C484.256 46.8983 498.717 -107.325 398.441 -102.632C380.353 -101.649 366.275 -96.3493 353.904 -87.3628C294.273 -43.307 289.752 84.677 164.741 178.392Z",
    fill: "#FCBF52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormaRight);
export default __webpack_public_path__ + "static/media/formaRight.0866832c5862aa526c00ba8d763d59fe.svg";
export { ForwardRef as ReactComponent };